module.exports = __webpack_public_path__ + "img/courses-5.09ca4322.jpg";